// Subdomain validation: lowercase alphanumeric with hyphens, 3-63 chars, can't start/end with hyphen
export const SUBDOMAIN_REGEX = /^[a-z0-9][a-z0-9-]{1,61}[a-z0-9]$/;

// Reserved subdomains that can't be used for projects. The endpoint worker refuses to
// serve them, so the API must refuse to hand them out.
export const RESERVED_SUBDOMAINS: ReadonlySet<string> = new Set(['www', 'api', 'app', 'admin', 'mock', 'mockd']);

export function validateSubdomain(subdomain: string): string | null {
  if (!SUBDOMAIN_REGEX.test(subdomain)) {
    return 'Invalid subdomain format. Must be 3-63 lowercase alphanumeric characters with hyphens, cannot start or end with hyphen.';
  }
  if (RESERVED_SUBDOMAINS.has(subdomain)) {
    return `'${subdomain}' is reserved. Choose a different subdomain.`;
  }
  return null;
}
